<template>
	<div
		id="lineup-wrapper"
		:class="{mobile: isMobile }"
	>
		<Lineup
			v-if="!isPlayerDetailsVisible"
			:table-header="tableHeader"
			:participants="participants"
			@open-player-details="openPlayerDetails"
		/>
		<LineupDetail
			v-else
			:details-labels="detailsLabels"
			:participant="currentPlayer"
			:participant-stats="playerStats"
			@back-to-line-up="backToLineup"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Lineup from '@components/Lineup';
import LineupDetail from '@components/LineupDetail';

export default {
	name:       'LineupBlock',
	components: { Lineup, LineupDetail },
	data() {
		return {
			isPlayerDetailsVisible: null,
			currentPlayer:          null,
			tableHeader:            {
				name:    this.$I18n.trans('commons.name'),
				age:     this.$I18n.trans('commons.age'),
				country: this.$I18n.trans('commons.country'),
			},
			detailsLabels: {
				nationality: this.$I18n.trans('commons.nationality'),
				born:        $I18n.trans('commons.born'),
				position:    $I18n.trans('commons.position'),
			},
		};
	},
	computed: {
		...mapGetters({
			isMobile:         'device/isMobile',
			event:            'event/event',
			sportName:        'event/sportName',
			_participants:    'event/participants',
			_lineup:          'event/lineup',
			eventStats:       'event/eventStats',
			eventPlayerStats: 'event/eventPlayerStats',
		}),
		participants() {
			const participants = this._participants.map((participant) => ({
				key:   participant.id,
				label: participant.club ? participant.club.code : participant.name,
				...participant,
			}));

			if (this._lineup.length === 0) {
				return participants;
			}

			return participants.map((participant) => {
				return Object.assign(participant, {
					players: this._lineup
						.filter(player => player.teamId === participant.id && !isNaN(player.number))
						.map(player => {
							return {
								...player.player,
								...player,
							};
						}),
				});
			});
		},
		playerStats() {
			const header = [
				this.$I18n.trans(`sports.${this.sportName}.stats.goals`).abbr,
				this.$I18n.trans(`sports.${this.sportName}.stats.attempts`).abbr,
				this.$I18n.trans(`sports.${this.sportName}.stats.goalkeeper_efficiency`).abbr,
				this.$I18n.trans(`sports.${this.sportName}.stats.seven_m_shot_goals`).abbr,
			];
			const body = [];

			const { data: playerLineupStats } = this.eventPlayerStats(this.currentPlayer?.player?.id) || {};

			if (!playerLineupStats) {
				return { header, body };
			}

			let shotEfficency = playerLineupStats.goalAttempts ? (playerLineupStats.goals / playerLineupStats.goalAttempts * 100) : 0;
			if (shotEfficency % 10 !== 0) shotEfficency = shotEfficency.toFixed(2);
			body.push(
				playerLineupStats.goals || 0,
				playerLineupStats.goalAttempts || 0,
				shotEfficency || 0,
			  playerLineupStats.sevenMShotGoals || playerLineupStats.sevenMShotAttempts
					? `${playerLineupStats.sevenMShotGoals || 0}/${playerLineupStats.sevenMShotAttempts || 0}`
					: '0',
			);

			// let header = [];
			// let body = [];

			// if (!playerLineupStats) {
			// 	return { header, body };
			// }

			// header = Object.keys(playerLineupStats);
			// body = Object.values(playerLineupStats);

			// header = header.map((column) => {
			// 	const snakeCaseColumnName = column
			// 		.replace(/([A-Z])/g, '_$1')
			// 		.replace(/_(Kilometers|Percent)$/, '')
			// 		.toLowerCase();

			// 	return (
			// 		this.$I18n.trans(`sports.${this.sportName}.stats.${format.prefix ? `${format.prefix}_${snakeCaseColumnName}` : snakeCaseColumnName}`).abbr ||
			// 		'NA'
			// 	);
			// });

			return {
				header,
				body,
			};
		},
	},
	methods: {
		openPlayerDetails(player = null) {
			this.currentPlayer = player;
			this.isPlayerDetailsVisible = !this.isPlayerDetailsVisible;
		},
		backToLineup() {
			this.openPlayerDetails();
		},
	},
};
</script>

<style lang="scss" scoped>

#lineup-wrapper {
	height: 100%;

	&.mobile {
		height: 100%;
	}
}

</style>
